// export { default } from './api'
export * from './api'
//这里面对应着四个方法 get put post del四个方法

import { http,get,post,put,del} from './api'


const apiServe = {
    // 确定好什么方法之后，直接传递参数过来就行，在这边写get post put del
    getIndexData: (data, method) => get('/api/index/index', data),
    getAboutData: (data, method) => get('/api/index/about', data),
    getHistoryData: (data, method) => get('/api/index/history', data),
    getProductData: (data, method) => get('/api/index/product', data),
    getAboutsData: (data, method) => get('/api/index/abouts', data),
    postMessageData: (data, method) => post('/api/index/message', data),
    postProductData: (data, method) => post('/api/index/productD', data),
}

export default apiServe